// extracted by mini-css-extract-plugin
export var scrollArea = "_qn-0";